import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rcsa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const msg = err.response?.data?.detail || "";
    const isSuperseded = typeof msg === "string" && msg.startsWith("session_superseded");
    if (err.response?.status === 401 && !err.config.url.includes("/auth/")) {
      localStorage.removeItem("rcsa_token");
      localStorage.removeItem("rcsa_user");
      if (window.location.pathname.startsWith("/app")) {
        const reason = isSuperseded ? "?reason=other_device" : "";
        window.location.href = `/login${reason}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
